/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */

expocadfx.openEmail = function( body) {
	'use strict';
	var config = expocadfx.config;
	var data = expocadfx.fxData;
	var fxStyle = expocadfx.styles;
	var txt = expocadfx.txt;
	var LinkPreview = expocadfx.LinkPreview;
	
//	var winLinkPreview = null;
	var subject =  encodeURIComponent( (config.eventTitle !== "") ? config.eventTitle:" ");
	
	if( body && config.bPreviewLink) {
		if( data.linkPreviewWindow === null) {
			data.linkPreviewWindow = new LinkPreview( txt, fxStyle);
		}

		data.linkPreviewWindow.content.textContent = body;
		data.linkPreviewWindow.window.style.display = "block";
	}
	else {
		var body = encodeURIComponent(body);
		window.location.href = "mailto:" + " " + "?subject=" + subject + "&body=" + body;
	}
};